export function ComputedFieldFunction(id, name, title, description, appliesTo, returnType, returnsDecimal, returnsPercentage)
{
    this.id = id;
    this.name = name;
    this.title = title;
    this.description = description;
    this.appliesTo = appliesTo;
    this.returnType = returnType;
    this.returnsDecimal = returnsDecimal;
    this.returnsPercentage = returnsPercentage;
}


ComputedFieldFunction.functions = [
    new ComputedFieldFunction(51, "Running Sum", "Running Sum", "", 2, 2, null, null),
    new ComputedFieldFunction(52, "Ratio To Sum", "Ratio To Sum","", 2, 2, true, true),
    new ComputedFieldFunction(53, "Variance", "Variance","", 2, 2, null, null),
    new ComputedFieldFunction(54, "Variance Ratio To Previous", "Variance Ratio To Previous", "", 2, 2, true, true),
    new ComputedFieldFunction(55, "Variance Ratio To Min.", "Variance Ratio To Min.","", 2, 2, true, true),
    new ComputedFieldFunction(56, "Variance Ratio To Max.", "Variance Ratio To Max.","", 2, 2, true, true),
    new ComputedFieldFunction(57, "Variance Ratio To Sum", "Variance Ratio To Sum","", 2, 2, true, true),
    new ComputedFieldFunction(58, "Variance Ratio To Average", "Variance Ratio To Average","", 2, 2, true, true),
    new ComputedFieldFunction(59, "Variance From Min.", "Variance From Min.", "", 2, 2, null, null),
    new ComputedFieldFunction(60, "Variance From Max.", "Variance From Max.", "", 2, 2, null, null),
    new ComputedFieldFunction(61, "Variance From Average", "Variance From Average", "", 2, 2, true, null),
    new ComputedFieldFunction(62, "Count All", "Count All", "", 0, 2, false, false),
    new ComputedFieldFunction(63, "Count Non Null", "Count Non Null", "", 0, 2, false, false),
    new ComputedFieldFunction(64, "Count Null", "Count Null", "", 0, 2, false, false),
    new ComputedFieldFunction(65, "Count All And Distint", "Count All And Distint", "", 0, 2, false, false),
    new ComputedFieldFunction(66, "Count Non Null And Distint", "Count Non Null And Distint", "", 0, 2, false, false),
    new ComputedFieldFunction(67, "Minimum", "Minimum", "", 2, 0, null, null),
    new ComputedFieldFunction(68, "Maximum", "Maximum", "", 2, 0, null, null),
    new ComputedFieldFunction(69, "Sum", "Sum", "", 2, 2, null, null),
    new ComputedFieldFunction(70, "Average",  "Average", "", 2, 2, true, null),
    new ComputedFieldFunction(71, "Standard Dev.", "Standard Dev.","", 2, 2, true, false),
    new ComputedFieldFunction(72, "Standard Dev. Distinct", "Standard Dev. Distinct", "", 2, 2, true, false),
    new ComputedFieldFunction(73, "Standard Dev. Pop.", "Standard Dev. Pop.", "", 2, 2, true, false),
    new ComputedFieldFunction(74, "Standard Dev. Pop. Distinct", "Standard Dev. Pop. Distinct", "", 2, 2, true, false),
    new ComputedFieldFunction(75, "Ratio To Previous", "Ratio To Previous","", 2, 2, true, true),
];

ComputedFieldFunction.where = function(predicate)
{
    let result = [];

    if(!predicate)
       return result;

    for(let entry in ComputedFieldFunction.functions)
    {
        if(predicate(ComputedFieldFunction.functions[entry]))
           result.push(new ComputedFieldFunction(entry.id, entry.title, entry.name, entry.description, entry.appliesTo, entry.returnType, entry.returnsDecimal, entry.returnsPercentage));
    }

    return result;
};

ComputedFieldFunction.isValidFunction = function(id)
{
    return ComputedFieldFunction.functions.find(e => e.id == id);
};

ComputedFieldFunction.getById = function(id)
{
    let entry = ComputedFieldFunction.functions.find(e => e.id == id);
    if(entry)
        return new ComputedFieldFunction(entry.id, entry.title, entry.name, entry.description, entry.appliesTo, entry.returnType, entry.returnsDecimal, entry.returnsPercentage);
    
    return null;
};

ComputedFieldFunction.prototype.getReturnTypeFromField = function(fieldType)
{
    return this.returnType === 2 ? 2 : fieldType;
};

ComputedFieldFunction.prototype.returnsDecimalFromFieldType = function(fieldIsDecimal)
{
    return (this.returnsDecimal === true || this.returnsDecimal === false) ? this.returnsDecimal : fieldIsDecimal
};

ComputedFieldFunction.prototype.returnsPercentageFromFieldType = function(fieldIsPercentage)
{
    return (this.returnsPercentage === true || this.returnsPercentage === false) ? this.returnsPercentage : fieldIsPercentage
};


ComputedFieldFunction.prototype.appliesToDataType = function(dataTypeId)
{
    if (dataTypeId < 1 || dataTypeId > 5)
        return false;

    if (this.appliesTo == 0)
        return true;

    if (dataTypeId == this.appliesTo)
        return true;

    if (this.appliesTo == 25 && (dataTypeId == 2 || dataTypeId == 4 || dataTypeId == 5))
        return true;

    return false;
}